import React from "react";
import "./OTPDisplay.css";

const OTPDisplay = ({ otp = "4829", onClose }) => {
  return (
    <div className="otp-inline-container">
      <h6>Delivery OTP</h6>
      <div className="otp-display-digits">
        {otp.split("").map((digit, index) => (
          <span key={index} className="otp-display-box">
            {digit}
          </span>
        ))}
      </div>
      <p className="otp-display-hint">
        Share this OTP with the delivery partner
      </p>
      {onClose && (
        <button className="btn-cancel-otp" onClick={onClose}>
          Hide
        </button>
      )}
    </div>
  );
};

export default OTPDisplay;
